// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cnic: CountryValidator<"PK"> = createValidator(
  "pk.cnic",
  144,
);

export default cnic;
export const compact = cnic.compact;
export const format = cnic.format;
export const validate = cnic.validate;
export const generate = (): string =>
  cnic.generate?.() ??
  (() => {
    throw new Error(
      "Validator pk.cnic cannot generate values",
    );
  })();
